define('resource-hero-text',['jquery'],
function ($) {
	var $this = $('.resource-hero h1');
	$(window).load(function(){
			if ($this.outerHeight() > 136 && !$this.hasClass('tall-text')) {
				$this.addClass('tall-text');
			}
			else if($this.hasClass('tall-text') && $this.outerHeight() <= 72 && $this.outerWidth() >= 340){
				$this.removeClass('tall-text');
			}
		}
	)
	$(window).resize(function () {
		if ($this.outerHeight() > 136 && !$this.hasClass('tall-text')) {
			$this.addClass('tall-text');
		}
		else if($this.hasClass('tall-text') && $this.outerHeight() <= 72 && $this.outerWidth() >= 340){
			$this.removeClass('tall-text');
		}
	});
});
